import React, { useState } from 'react';
import InputForm from '../../../InputT';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import { Box, CircularProgress, TextField, Tooltip, Typography } from '@mui/material';
import { Button, Input, Select } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { Clear, DataArray, MonetizationOn, MonetizationOnOutlined, Money, Phone, SwipeUp } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../Models/Utilisateur';
import SearchInput from '../../../SearchInput';
import CheckBox from '../../../CheckBox';
import SearchModal from '../../../SearchModal';
import RadioBox from '../../../Radiox';
import TextArea from 'antd/es/input/TextArea';
import Datas from "../../../../Data/Data.json"
import { Crypter } from '../../../../Functions/Security/Crypter';
import axios from 'axios';
import DataTypeTable from '../../../../Types/DataTypeTable';
import SweetAlert from "sweetalert2"
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import Data from '../../../../Data/Data.json'
import { DownOutlined } from '@ant-design/icons';
import Spin from 'antd/es/spin';
import { ColumnsType } from 'antd/es/table';
import Table from '../../../TableResizable';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import formatDate from '../../../../Functions/Traitement/fomatDate';







//Initialisation des parametres de recherche
//
let searchGes: Params = { CodeAgence: '', Table: "GESTIONNAIRE", Colonne1: "CODGES", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchIndice: Params = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }
let searchPeriod: Params = { CodeAgence: '', Table: "v_period_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchTypeAmort: Params = { CodeAgence: '', Table: "v_typeAmortissement_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchTypeCalcul: Params = { CodeAgence: '', Table: "v_typeCalcul_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchTypePret: Params = { CodeAgence: '', Table: "TYPEPRET", Colonne1: "TYPEPRET", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }

interface SelectData {
  value: string,
  label: string,
}

function Tab1(props: { form?: any }) {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const [competClients, SetCompetClients] = React.useState<SelectData[]>([]);
  const [loading, setLoading] = useState(false)
  const [loadCompte, setLoadCompte] = useState(false)
  //const [historiques, setHistoriques] = useState<Array<any>>([])
  


  // USER TOKEN
  const authHeader = useAuthHeader()



  
  const columns: ColumnsType<any> = [
    {
      title: 'Montant',
      dataIndex: 'MTDEC',
    },
    {
      title: 'Utilisateur',
      dataIndex: 'UTIDEC',
    },
    {
      title: 'Date',
      dataIndex: 'DATDEC',
    },
    {
      title: 'Raison',
      dataIndex: 'RAISON',
    }
  ];


  function loadGarantie() {
    localStorage.setItem("garanties_client", "")
    localStorage.setItem(Datas.LocalVariable.garantie, "")
    try {
      let numcli = props.form.getFieldValue("NUMCLI")
      numcli += Datas.LocalVariable.separator + "CL"

      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.GetGarantie,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherSearch': Crypter.encrypt(JSON.stringify(numcli))
        }
      };
      axios(config)
        .then((response) => {
          //alert('ok')
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;


            if (res.StatutCode == 200) {
              let datas = res.Result.Table;

              //alert(datas.length)
              if (datas.length === 0) {
                localStorage.setItem("garanties_client", "")
              }
              else {
                localStorage.setItem("garanties_client", Crypter.encrypt(JSON.stringify(datas)))
              }
            }
          }

        }).catch((error) => {
          localStorage.setItem("garanties_client", "")
          SweetAlert.fire({ title: "Error", text: error })
        })
    } catch (error) {
      SweetAlert.fire({ title: "Veillez sélectionnez le client donc vous voulez charger les garantie", icon: "warning" })
      localStorage.setItem("garanties_client", "")
    }
  }

  function loadAvaliste() {
    localStorage.setItem("avalistes_client", "")
    localStorage.setItem(Datas.LocalVariable.garantie, "")
    try {
      let numcli = props.form.getFieldValue("NUMCLI")
      //numcli += Datas.LocalVariable.separator + "CL"
      //alert(numcli)
      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.GetRelation,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherNumcli': Crypter.encrypt(JSON.stringify(numcli))
        }
      };
      axios(config)
        .then((response) => {
          //alert('ok')
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data));


            if (res.StatutCode == 200) {
              let datas = res.Result.Table;

              //alert(datas.length)
              if (datas.length === 0) {
                localStorage.setItem("avalistes_client", "")
              }
              else {
                localStorage.setItem("avalistes_client", Crypter.encrypt(JSON.stringify(datas)))
              }
            }
          }

        }).catch((error) => {
          localStorage.setItem("avalistes_client", "")
          SweetAlert.fire({ title: "Error", text: error })
        })
    } catch (error) {
      SweetAlert.fire({ title: "Veillez sélectionnez le client donc vous voulez charger les garantie", icon: "warning" })
      localStorage.setItem("avalistes_client", "")
    }
  }

  // function loadHistorique() {
  //   try {
  //     let hist = JSON.parse(Crypter.decrypt(localStorage.getItem("historique_decaissement")+"")) as Array<any>
  //     var newHist: Array<any> = []
  //     hist.map((h: any)=>{
  //       newHist.push(
  //         {
  //           "MTDEC": formatNumber(h.MTDEC) +" XAF",
  //           "UTIDEC": h.UTIDEC,
  //           "DATDEC": ReformatDate(h.DATDEC),
  //           "RAISON": <Tooltip title={h.RAISON}><label>? (Pointez)</label></Tooltip>
  //         }
  //       )
  //     })
  //     setHistoriques(newHist)
  //   } catch (error) {
      
  //   }
  // }

  // setTimeout(() => {
  //   try {
  //     let reset = localStorage.getItem(Datas.LocalVariable.reset)
  //     let compte = props.form.getFieldValue("CPTORDI")
  //     let compteEpargne = props.form.getFieldValue("CPTEPARG")

  //     setNumcpt(compte)
  //     setNumcptEpargne(compteEpargne)
  //     if (reset == "1") {
  //       setNumcli("")
  //       setNumcpt("")
  //       setNumcptEpargne("")
  //       //setHistoriques([])
  //     }
  //     //localStorage.removeItem(Data.LocalVariable.reset)
  //   }
  //   catch (error) {
  //     console.log(error)
  //   }

  //   // try {
  //   //   let isOkay = localStorage.getItem("load_compte")
  //   //   if (isOkay == "1") {
  //   //     loadHistorique()
  //   //   }
  //   //   localStorage.removeItem("load_compte")
  //   // } catch (error) {}
  // }, 1);



  return (
    <div className='tabItemAuto'>
      <div >
        <Box display={'flex'} fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>
          <Box fontStyle="inherit" className='border-left'>
            {/* <SearchModal   width={9} form = {props.form}  Titre='Recherche Utilisateur'  label='Code' name='coduti' Parametre={searchUser}/> */}
            <InputForm notRequired disabled  width={9} label='Numéro Demande' name='NUMDOS' type={'text'} />
            <SearchModal disabled width={9} form={props.form} Titre="Recherche Indice client" label='Indice client' name='NUMCLI' Parametre={searchIndice} />
            <SearchModal notRequired width={9} form={props.form} Titre="Recherche Type de pret" label='Type de pret' name='TYPEPRET' Parametre={searchTypePret} />
            <SearchModal width={9} form={props.form} Titre="Recherche Gestionnaire" label='Gestionnaire' name='CODGES' Parametre={searchGes} />
            <InputForm notRequired defaultValue={user.datjour} width={9} label='Date Demande' icon={<SwipeUp color='disabled' fontSize='small' />} name='DATEDEM' type='date' error='mobile' />
            <SearchModal width={9} form={props.form} Titre="Recherche Type Amortissement" label='Type Amort' name='TYPAMORT' Parametre={searchTypeAmort} />
            <InputForm notRequired width={9} label='Taux épargne' icon={<MonetizationOnOutlined fontSize='small' />} name='TAUXEPAR' type='number' error='mobile' />
            <InputForm notRequired width={9} label='Montant Epargne' icon={<MonetizationOnOutlined fontSize='small' />} name='MONTEPARG' type='number' error='mobile' />
          </Box>

          <Box fontStyle="inherit" className='border-left'>
            <InputForm notRequired width={9} label='Taux Intéret' icon={<MonetizationOnOutlined fontSize='small' />} name='TAUXINT' type='number' error='mobile' />
            <InputForm notRequired width={9} label='Taux Taxe' icon={<MonetizationOnOutlined fontSize='small' />} name='TAUXTAX' type='number' error='mobile' />
            <InputForm notRequired width={9} label='Nbre échéance' icon={<MonetizationOnOutlined fontSize='small' />} name='NBRECHE' type='number' error='mobile' />
            <InputForm notRequired width={9} label='Nbre Pde diféré' icon={<MonetizationOnOutlined fontSize='small' />} name='NBPERDIF' type='number' error='mobile' />
            <SearchModal width={9} form={props.form} Titre="Recherche Périodicité" label='Périodicité' name='PERIODIC' Parametre={searchPeriod} />
            <InputForm notRequired width={9} label='Dte 1ère Ech' icon={<MonetizationOnOutlined fontSize='small' />} name='DAT1ECHE' type='date' error='mobile' />
            <SearchModal width={9} form={props.form} Titre='Recherche Type Calcul' label='Type Calcul' name='TYPCALC' Parametre={searchTypeCalcul} />
          </Box>
          <Box fontStyle="inherit" className='border-left'>
            {/* <Spin spinning={loading}>
              <legend>Historique de décaissement</legend>
              <Table size='small' style={{ width: '400px' }} columns={columns} dataSource={historiques} scroll={{x:10, y: 180}}  pagination={false} />
            </Spin> */}
            
            <legend>Détail Décaissement</legend>
            <InputForm notRequired width={17} label='Nombre Decaissement' name='nbDec' type='text' error='mobile' />
            <InputForm notRequired width={11} label='Mtn Validé' icon={<MonetizationOnOutlined fontSize='small' />} name='MONTAN' type='text' error='mobile' />
            <InputForm notRequired disabled width={11} label='Mtn Décaissé' icon={<MonetizationOnOutlined fontSize='small' />} name='mntdecaisse' type='text' error='mobile' />
            <InputForm notRequired disabled width={11} label='Mtn restant' icon={<MonetizationOnOutlined fontSize='small' />} name='MTREST' type='text' error='mobile' />
            <InputForm disabled={false} width={11} label='Mt à décaisser' icon={<MonetizationOnOutlined fontSize='small' />} name='MTDEC' type='number' error='mobile' />
            <InputForm row={1} disabled={false} width={11} label='Raison' icon={<MonetizationOnOutlined fontSize='small' />} name='RAISON' type='TextArea' error='mobile' />
            <legend>...</legend>
          </Box>
        </Box>
      </div>
    </div>

  )
}
export default Tab1;

// values.NUMCLI, values.PERIODIC, values.MONTEPARG, values.TAUXINT, values.NBPERDIF, values.TYPEPRET, values.TYPAMORT, values.TAUXEPAR, values.NBRECHE, values.MONTAN, values.TYPCALC, values.TAUXTAX, ReformatDate(values.DAT1ECHE), values.MTNCOM1 + values.MTNCOM2 + values.MTNCOM3 + values.MTNCOM4 + values.MTNCOM5